import { dispatch } from '~/state';

const CampaignClient = {
  ad: {
    setBudget: budget => dispatch({ type: 'setBudget', payload: budget }),
    setAdLength: length => dispatch({ type: 'setAdLength', payload: length }),
    changeType: type => dispatch({ type: 'changeAdType', payload: type }),
    revertType: () => dispatch({ type: 'revertAdType' }),
    changeName: name => dispatch({ type: 'changeAdName', payload: name }),
  },
  searchId: {
    set: id => dispatch({ type: 'changeSearchId', payload: id }),
  },
  endCard: {
    toggle: () => dispatch({ type: 'toggleEndCard' }),
  },
  link: {
    analyzed: (link) => dispatch({ type: 'linkAnalyzed', payload: link }),
  },
};

export default CampaignClient;
